import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import Mileage from './Mileage'
import PropTypes from 'prop-types'
import { actions } from '../Services/Mileage'
import { filterPartnerMileage } from '../Services/Mileage/actions'

import twoFactorAuthentication from '../Checkout/actions'
import FingerPrintContainer from 'App/FingerPrint/FingerPrintContainer'

import { validate as validateCPF } from 'gerador-validador-cpf'

class MileageContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      vendorId: 0,
      formValid: false,
      timer: 0,
      inputPointsValue: 0,
      formMessage: '',
      points: '',
      loyaltyNumber: '',
      convertAllPoints: false,
      acceptTerms: false,
      showModal: false,
      partnerName: '',
      disabledFields: true,
      disableLoyaltyNumber: true,
      confirmationModal: false
    }
  }

  componentDidMount () {
    this.props.getPartners()
    this.props.clearCalculator()
    this.props.getPartnersWithConfigurations(this.props.catalog.id)
  }

  handleConfirmationModal = () => {
    this.setState({
      confirmationModal: !this.state.confirmationModal
    })
  }

  showTermsEvent = () => {
    this.setState({
      showModal: true
    })
  }

  acceptTermsEvent = checked => {
    this.setState({
      showModal: false,
      acceptTerms: checked
    })
  }

  acceptTerms = accept => {
    this.setState({ acceptTerms: accept })
  }

  closeterms = () => {
    this.setState({ showModal: false })
  }

  fidelityLabelConfig = vendorId => {
    var filter =
      this.props.configuration &&
      this.props.configuration[vendorId] &&
      this.props.configuration[vendorId].filter(
        x => x.key === 'LoyaltyNumberLabel'
      )

    if (filter && filter.length > 0) {
      return filter[0].value
    }
    return null
  }

  selectPartnersOnChange = item => {
    if (item === null || item === undefined || item === '') {
      this.setState({ points: '', vendorId: 0 })
      this.props.clearCalculator()
      return
    }

    setTimeout(() => {
      this.setState({
        vendorId: item.vendorId,
        formValid: true,
        partnerName: item.name,
        disabledFields: false,
        disableLoyaltyNumber: this.MapLoyaltNumberType(item.vendorId),
        acceptTerms: false,
        convertAllPoints: false,
        fidelityLabel: this.fidelityLabelConfig(item.vendorId),
        loyaltyNumber: this.MapLoyaltNumberType(item.vendorId)
          ? this.props.participant.cpf.value
          : this.state.loyaltyNumber
      })

      this.props.clearCalculator()
      this.props.pointsToMiles(this.state.vendorId, this.state.points)
    }, 1000)
  }

  inputPointsOnChange = event => {
    const value = event.target.value

    if (value.length >= 7) return

    const onlyNumbers = value.match(/\d+/g)
    if (onlyNumbers) {
      this.inputPointsOnblur(event)
      return this.setState({ points: onlyNumbers.join([]) })
    }
    this.setState({ points: '' })
  }

  inputLoyaltNumberOnChange = ({ target: { value } }) => {
    const onlyNumbers = value.match(/\d+/g)
    if (onlyNumbers) {
      return this.setState({ loyaltyNumber: onlyNumbers.join([]) })
    }
    this.setState({ loyaltyNumber: '' })
  }

  mountNumberValidation = event => {
    if (
      event.key === '0' ||
      event.key === '1' ||
      event.key === '2' ||
      event.key === '3' ||
      event.key === '4' ||
      event.key === '5' ||
      event.key === '6' ||
      event.key === '7' ||
      event.key === '8' ||
      event.key === '9' ||
      event.key === 'Enter' ||
      event.key === 'Backspace' ||
      event.key === 'Delete'
    ) {
      return true
    } else {
      return false
    }
  }

  inputPointsOnblur = event => {
    clearTimeout(this.state.timer)
    this.setState({
      inputPointsValue: event.target.value,
      timer: setTimeout(() => {
        this.setState({
          formValid: true,
          formMessage: '',
          points: this.state.inputPointsValue
        })
        this.props.pointsToMiles(this.state.vendorId, this.state.points)
      }, 400)
    })
  }

  handleConvertAllPoints = event => {
    if (!event.target.checked) {
      this.props.clearCalculator()
    }

    this.setState({ convertAllPoints: event.target.checked })
    const balance = Math.floor(this.props.partBalance, 0)

    if (event.target.checked) {
      this.setState({ points: balance })
      this.props.pointsToMiles(this.state.vendorId, balance)
    } else {
      this.setState({ points: 0 })
      this.props.pointsToMiles(this.state.vendorId, 0)
    }
  }

  handleFormatValue = value => {
    if (!isNaN(value)) {
      return `${parseFloat(value).toLocaleString('pt-br', {
        minimumFractionDigits: this.props.currencyConfiguration.decimalPlaces,
        maximumFractionDigits: this.props.currencyConfiguration.decimalPlaces
      })} ${'Milhas'}`
    }
    return ''
  }

  handlerFinalizePayment = () => {
    const MinimumBalance = this.mapProp('MinimumBalance')
    const MinimunRedemption = this.mapProp('MinimumRedemptionLimit')

    if (this.props.partBalance < this.state.points) {
      this.props.errorBalanceRedemption()
    } else if (this.props.partBalance < MinimumBalance) {
      this.props.errorMinimunBalanceRedemption(MinimumBalance)
    } else if (this.state.points < MinimunRedemption) {
      this.props.errorMinimunRedemption(MinimunRedemption)
    } else {
      this.props.mileageRedemption(this.getOrderRequest(), this.state.vendorId)
    }
  }

  handlerCloseError = () => {
    this.props.closeErrorMileage()
  }

  mapProp = KeyName => {
    var filter = this.props.configuration[this.state.vendorId].filter(
      x => x.key === KeyName
    )

    if (filter.length > 0) {
      return filter[0].value
    }
  }

  mapOrderProcessType = (
    KeyValue = 'OrderProcessType',
    NameValue = 'Queue'
  ) => {
    var result = false
    var filter = this.props.configuration[this.state.vendorId].filter(
      x => x.key === KeyValue
    )

    if (filter.length > 0) {
      var item = filter[0]

      if (item.value === NameValue) {
        result = true
      }

      return result
    }
  }

  MapLoyaltNumberType = vendorId => {
    var filter =
      this.props.configuration &&
      this.props.configuration[vendorId] &&
      this.props.configuration[vendorId].filter(
        x => x.key.toLowerCase() === 'transferkey'
      )

    if (filter && filter.length > 0) {
      var item = filter[0]

      if (item.value.toLowerCase() === 'cpf') {
        return true
      } else {
        this.setState({ loyaltyNumber: '' })
        return false
      }
    }
  }

  cpfValidator = cpf => {
    var filter =
      this.props.configuration &&
      this.props.configuration[this.state.vendorId] &&
      this.props.configuration[this.state.vendorId].filter(
        x => x.key.toLowerCase() === 'transferkey'
      )

    if (filter && filter.length > 0) {
      var item = filter[0]

      if (item.value.toLowerCase() === 'cpf') {
        if (!validateCPF(cpf.target.value)) {
          this.props.errorCpfMileage()
        }
      }
    }
  }

  getOrderRequest = () => ({
    totalMiles: this.state.points,
    totalPoints: this.props.calculator.miles,
    catalogId: this.props.participant.catalogId,
    transferKey: 'cpf',
    loyaltyNumber: this.state.loyaltyNumber,
    cpf: this.props.participant.cpf.value,
    participantName: this.props.participant.name.value,
    offline: this.mapOrderProcessType(),
    orderItems: [
      {
        quantity: 1,
        points: this.props.calculator.miles,
        miles: this.state.points,
        totalPoints: this.props.calculator.miles,
        packageName: this.handleFormatValue(this.props.calculator.miles)
      }
    ],
    orderTypeId: 1
  })

  render () {
    return (
      <Fragment>
        <FingerPrintContainer />
        <Mileage
          {...this.state}
          partners={this.props.partners}
          points={this.state.points}
          miles={this.props.calculator.miles}
          selectPartnersOnChange={this.selectPartnersOnChange}
          showModal={this.state.showModal}
          inputPointsOnblur={this.inputPointsOnblur}
          inputPointsOnChange={this.inputPointsOnChange}
          handlerFinalizePayment={this.handlerFinalizePayment}
          handleConfirmationModal={this.handleConfirmationModal}
          confirmationModal={this.state.confirmationModal}
          handlerCloseError={this.handlerCloseError}
          handlerCloseSuccess={this.handlerCloseSuccess}
          acceptTermsEvent={this.acceptTermsEvent}
          closeterms={this.closeterms}
          showTermsEvent={this.showTermsEvent}
          vendorId={this.state.vendorId}
          inputLoyaltNumberOnChange={this.inputLoyaltNumberOnChange}
          loyaltyNumber={this.state.loyaltyNumber}
          partnerName={this.state.partnerName}
          currencyConfiguration={this.props.currencyConfiguration}
          errorRedemption={this.props.errorRedemption}
          handleConvertAllPoints={this.handleConvertAllPoints}
          convertAllPoints={this.state.convertAllPoints}
          disabledFields={this.state.disabledFields}
          handleFormatValue={this.handleFormatValue}
          loadingPayment={this.props.sendRedemptionMileage}
          validateCPF={this.cpfValidator}
          disableLoyaltyNumber={this.state.disableLoyaltyNumber}
          sendTwoFactorAuthorization={this.props.sendTwoFactorAuthorization}
          authorizeWithTokenMileage={this.props.authorizeWithTokenMileage}
          authorizeWithTokenResend={this.props.authorizeWithTokenResend}
          authorizeWithTokenLastTry={this.props.authorizeWithTokenResend}
          loadingResendToken={this.props.loadingResendToken}
          closeModalShowError={this.props.closeModalShowError}
        />
      </Fragment>
    )
  }
}

const partnerMessage = PropTypes.shape({
  name: PropTypes.string.isRequired,
  vendorId: PropTypes.number.isRequired
})

const calculatorMessage = PropTypes.shape({
  points: PropTypes.string,
  miles: PropTypes.string
})

MileageContainer.propTypes = {
  cpf: PropTypes.object,
  redirectConfirmation: PropTypes.func,
  partners: PropTypes.arrayOf(partnerMessage).isRequired,
  calculator: PropTypes.arrayOf(calculatorMessage),
  isLoading: PropTypes.bool.isRequired,
  isLoadingCalculator: PropTypes.bool.isRequired,
  getPartners: PropTypes.func.isRequired,
  pointsToMiles: PropTypes.func.isRequired,
  clearCalculator: PropTypes.func,
  partBalance: PropTypes.number,
  mileageRedemption: PropTypes.func.isRequired,
  participant: PropTypes.object,
  errorRedemption: PropTypes.string,
  currencyConfiguration: PropTypes.object,
  closeErrorMileage: PropTypes.func,
  sendRedemptionMileage: PropTypes.bool,
  errorBalanceRedemption: PropTypes.func,
  errorMinimunRedemption: PropTypes.func,
  errorCpfMileage: PropTypes.func,
  getMileageConfigurations: PropTypes.func,
  catalog: PropTypes.func,
  errorMinimunBalanceRedemption: PropTypes.func,
  getPartnersWithConfigurations: PropTypes.func,
  configuration: PropTypes.object,
  id: PropTypes.number.isRequired,
  sendTwoFactorAuthorization: PropTypes.bool,
  authorizeWithTokenMileage: PropTypes.func,
  authorizeWithTokenResend: PropTypes.func,
  authorizeWithTokenLastTry: PropTypes.func,
  loadingResendToken: PropTypes.bool,
  closeModalShowError: PropTypes.func
}

const mapStateToProps = ({
  mileage,
  balance,
  participant,
  catalog: { currencyConfiguration },
  catalog
}) => ({
  partners: filterPartnerMileage(mileage.partners, true),
  calculator: mileage.calculator,
  isLoading: mileage.isLoading,
  isLoadingCalculator: mileage.isLoadingCalculator,
  getPartners: mileage.getPartners,
  pointsToMiles: mileage.pointsToMiles,
  partBalance: balance.pointsValue,
  participant: participant,
  catalog: catalog,
  errorRedemption: mileage.errorRedemption,
  sendRedemptionMileage: mileage.sendRedemptionMileage,
  currencyConfiguration,
  configuration: mileage.configuration,
  sendTwoFactorAuthorization: mileage.sendTwoFactorAuthorization,
  loadingResendToken: mileage.loadingResendToken
})

const mapDispatchToProps = dispatch => ({
  clearCalculator: () => dispatch(actions.clearCalculator()),
  getPartners: () => dispatch(actions.getPartners()),
  pointsToMiles: (supplierId, points) =>
    dispatch(actions.convertPointsToMiles(supplierId, points)),
  mileageRedemption: (order, supplierId) =>
    dispatch(actions.mileageRedemption(order, supplierId)),
  closeErrorMileage: () => dispatch(actions.closeErrorMileage()),
  errorBalanceRedemption: MinimumBalance =>
    dispatch(actions.errorBalanceRedemption(MinimumBalance)),
  errorMinimunRedemption: MinimunRedemption =>
    dispatch(actions.errorMinimunRedemption(MinimunRedemption)),
  errorMinimunBalanceRedemption: minimunBalanceRedemption =>
    dispatch(actions.errorMinimunBalanceRedemption(minimunBalanceRedemption)),
  errorCpfMileage: () => dispatch(actions.errorCpfMileage()),
  getMileageConfigurations: (catalogId, supplierId) =>
    dispatch(actions.getMileageConfigurations(catalogId, supplierId)),
  getPartnersWithConfigurations: catalogId =>
    dispatch(actions.getPartnersWithConfigurations(catalogId)),
  authorizeWithTokenMileage: (
    orderId,
    Token,
    orderIdMileage,
    vendorId,
    lastTry
  ) =>
    dispatch(
      actions.authorizeWithTokenMileage(
        orderId,
        Token,
        orderIdMileage,
        vendorId,
        lastTry
      )
    ),
  authorizeWithTokenResend: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      twoFactorAuthentication.authorizeWithTokenResend(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    ),
  authorizeWithTokenLastTry: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      twoFactorAuthentication.authorizeWithTokenLastTry(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    ),
  closeModalShowError: error => dispatch(actions.closeModalShowError(error))
})

export default connect(mapStateToProps, mapDispatchToProps)(MileageContainer)



// WEBPACK FOOTER //
// ./src/features/MileageRescue/MileageContainer.js